import React, {useState} from "react";
import AsyncStateWrapper, {QueryState} from "../components/common/AsyncStateWrapper";
import {Select, MenuItem, Button} from "@mui/material";
import {Link, useParams} from 'react-router-dom';
import {useGetLifetimeStatsQuery} from "../store/playerLifetimeStats/playerLifetimeStatsApiSlice";
import StatlineData from "../components/Statline/StatlineData";
import {useGetSeasonStatsQuery} from "../store/playerSeasonStats/playerSeasonStatsApiSlice";
import StatlineHeader from "../components/Statline/StatlineHeader";
import PlayerInfo from "../components/PlayerInfo/PlayerInfo";
import PlayerSeasonStatsTable from "../components/PlayerSeasonStatsTable/PlayerSeasonStatsTable";
import {useGetPlayerInfoQuery} from "../store/players/playerApiSlice";
import {useLazyGetPlayerGameLogsQuery} from "@/store/playerGameLog/playerGameLogApiSlice";
import PlayerGameLog from "@/components/PlayerGameLog/PlayerGameLog";
import {useGetYearlyStatsQuery} from "@/store/playerYearlyStats/playerLifetimeStatsApiSlice";
import PlayerYearlyStatsTable from "@/components/PlayerYearlyStatsTable/PlayerSeasonStatsTable";

const PlayerPage = () => {

    const {playerId} = useParams();
    const [selectedSeasonId, setSelectedSeasonId] = useState(0);

    const getPlayerInfo = useGetPlayerInfoQuery(parseInt(playerId!));
    const getPlayerLifetimeStatsQuery = useGetLifetimeStatsQuery(parseInt(playerId!));
    const getPlayerYearlyStatsQuery = useGetYearlyStatsQuery(parseInt(playerId!));
    const getPlayerSeasonStatsQuery = useGetSeasonStatsQuery(parseInt(playerId!));
    const [getPlayerGameLogsTrigger, getPlayerGameLogsQuery] = useLazyGetPlayerGameLogsQuery();

    const updateSeasonForGameLogs = (seasonId : number) => {
        setSelectedSeasonId(seasonId);
        getPlayerGameLogsTrigger({playerId : parseInt(playerId!), seasonId : seasonId});
    }

    return (
        <div className="content">
            <AsyncStateWrapper query={getPlayerInfo as QueryState} >
                <PlayerInfo player={getPlayerInfo.data!} />

                <AsyncStateWrapper query={getPlayerLifetimeStatsQuery as QueryState} >
                    <h3>
                        Lifetime Stats
                    </h3>
                    <table className="table">
                        <thead className="table-header">
                        <tr>
                            <StatlineHeader games={true} displayWrcPlus={true} />
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <StatlineData statline={getPlayerLifetimeStatsQuery.data!} displayWrcPlus={true} />
                        </tr>
                        </tbody>
                    </table>
                </AsyncStateWrapper>
                <AsyncStateWrapper query={getPlayerYearlyStatsQuery as QueryState} >
                    <h3>
                        Yearly Stats
                    </h3>
                    <PlayerYearlyStatsTable yearlyStats={getPlayerYearlyStatsQuery.data!} />
                </AsyncStateWrapper>
            </AsyncStateWrapper>

            {
                getPlayerSeasonStatsQuery.data && (
                    <AsyncStateWrapper query={getPlayerSeasonStatsQuery as QueryState} >
                        <h3>
                            Season Stats
                        </h3>
                        <PlayerSeasonStatsTable seasonStats={getPlayerSeasonStatsQuery.data!} />

                        <h3>
                            Game Logs
                        </h3>
                        <Select
                            value={selectedSeasonId}
                            label="Player"
                            onChange={(e) => updateSeasonForGameLogs(e.target.value as number)}
                        >
                            <MenuItem value={0}>
                                Season
                            </MenuItem>
                            {getPlayerSeasonStatsQuery.data.map(seasonStats => seasonStats.season).map(season => (
                                <MenuItem value={season.id}>
                                    {`${season.session}, ${season.year}`}
                                </MenuItem>
                            ))}
                        </Select>
                    </AsyncStateWrapper>
                )
            }

            {selectedSeasonId > 0 && (
                <AsyncStateWrapper query={getPlayerGameLogsQuery as QueryState} >
                    <PlayerGameLog games={getPlayerGameLogsQuery.data!} />
                </AsyncStateWrapper>
            )}
            <br/>
            <br/>

            <Link to={`/advancedPlayerData/${playerId}`}>Advanced Player Data</Link>
        </div>
    )
}

export default PlayerPage;
